window.Shopify.Products.showRecentlyViewed( { howManyToShow: window.showRecentlyViewedCustomSettings.howManyToShow, howManyToStoreInMemory: 12, onComplete: showRecentlyViewedOnComplete() } );

function showRecentlyViewedOnComplete() {
	// console.log('showRecentlyViewedOnComplete')
}